import { reactive } from 'vue';

export const criarPlaLeite = () => {
  return reactive({
    id: 0,
    idestabelecimento: 0,
    subtipo: '',
    anomes: 0,
    protocolo: '',
    idresponsavel: 0,
    nmresponsavel: '',
    idrt: 0,
    nmrt: '',
    lgdigitacao: 0,
    rtdigitacao: 'N',
    informacoes: '',
    idstatus: 0,
    idlogin: 0,
    idusuario: 0
  });
};